/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type magic_standard_full = {
  id: string;
  version_id: number;
  magic_item_category_id: number | null;
  hidden: boolean;
  max: number;
  value_points: number;
  name: string | null;
  description: string | null;
  infos: string | null;
  organisation_id: number | null;
  organisation_mode: magic_standard_full.organisation_mode;
};
export namespace magic_standard_full {
  export enum organisation_mode {
    UNIT = 'Unit',
  }
}
